import { styled } from "styled-components";




export const InputSection = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 10px;
    gap:15px;
    
    align-items: center;
    
`;
